export interface RouteObj {
  name: string;
  path?: string[];
  subRoutes?: Promise<Route>[];
  icon: string;
  disabled?: boolean;
  iconStyle?: any;
  iconClass?: string;
  showFunction?: () => Promise<boolean> | boolean | undefined;
  code?: string;
  sidebarOverride?: string;
}

export interface Route {
  name: string;
  subRoutes?: Route[];
  path?: string[];
  icon: string;
  opened?: boolean;
  disabled?: boolean;
  iconStyle?: any;
  iconClass?: string;
  showFunction?: () => Promise<boolean> | boolean | undefined;
  code?: string;
  show?: boolean;
  closed?: boolean;
  sidebarOverride?: string;
}

export async function createRoute(routeObj: RouteObj): Promise<Route> {
  const route = new RouteClass(routeObj);
  await route.initShow();
  return route;
}

class RouteClass implements Route {
  private subRoutesPromiseArr?: Promise<Route>[];
  name: string;
  subRoutes?: Route[];
  path?: string[];
  icon: string;
  opened = false;
  disabled?: boolean;
  iconStyle?: any;
  iconClass?: string;
  showFunction?: () => Promise<boolean> | boolean | undefined;
  code?: string;
  show!: boolean;
  sidebarOverride?: string;
  constructor(routeObj: RouteObj) {
    this.name = routeObj.name;
    this.subRoutesPromiseArr = routeObj.subRoutes;
    this.path = routeObj.path;
    this.icon = routeObj.icon;
    this.disabled = routeObj.disabled;
    this.iconClass = routeObj.iconClass;
    this.iconStyle = routeObj.iconStyle;
    this.code = routeObj.code;
    this.showFunction = routeObj.showFunction;
    this.sidebarOverride = routeObj.sidebarOverride;
  }

  async initShow() {
    let show = false;
    if (this.showFunction) {
      show = await Promise.resolve(this.showFunction()!);
    } else {
      show = true;
    }

    if (show && this.subRoutesPromiseArr?.length) {
      this.subRoutes = await Promise.all(this.subRoutesPromiseArr);
      const hasSubRouteWithShow = !!this.subRoutes.find(
        (subroute) => subroute.show,
      );
      show = show && hasSubRouteWithShow;
    }

    this.show = show;
  }

  get closed() {
    return !this.opened;
  }

  set closed(value) {
    this.opened = !value;
  }
}
